import { DiceD8OutlineIcon } from './DiceD8OutlineIcon';

/**
 * author: Austin Andrews
 * id 64967BE6-CAAF-4F28-BF55-C5451D4E8B94
 * name dice-d8-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-d8-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const DieD8Icon = DiceD8OutlineIcon;
export default DieD8Icon